import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";

export default function Topbar({
  sidebarOpen,
  setSidebarOpen,
  user,
  profileAnchor,
  openProfileMenu,
  closeProfileMenu,
  handleLogout,
  getColorFromName,
}) {
  return (
    <Box
      sx={{
        height: 56,
        px: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "#07233d",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <IconButton
        onClick={() => setSidebarOpen(!sidebarOpen)}
        sx={{ color: "#fff" }}
      >
        {sidebarOpen ? <MenuOpenIcon /> : <MenuIcon />}
      </IconButton>

      <Typography
        variant="h5"
        sx={{
          color: "#fff",
          fontWeight: 500,
          fontSize: 19,
        }}
      >
        support.au@worldoptions.com
      </Typography>

      <Box
        onClick={openProfileMenu}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          cursor: "pointer",
        }}
      >
        <Avatar
          sx={{
            bgcolor: getColorFromName(
              user?.full_name || user?.username || "User",
            ),
          }}
        >
          {(user?.full_name || user?.username || "U")
            .split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase()}
        </Avatar>

        <Box>
          <Typography sx={{ color: "#fff", fontSize: 14 }}>
            {user?.full_name}
          </Typography>

          <Typography sx={{ color: "#94a3b8", fontSize: 12 }}>
            {user?.username}
          </Typography>
        </Box>

        <KeyboardArrowDownIcon sx={{ color: "#94a3b8" }} />

        <Menu
          anchorEl={profileAnchor}
          open={Boolean(profileAnchor)}
          onClose={closeProfileMenu}
        >
          <MenuItem
            onClick={() => {
              closeProfileMenu();
              handleLogout();
            }}
          >
            <LogoutIcon sx={{ mr: 1 }} />
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
}
